import React from 'react';
import './com_1.css';


const Celestial = () => {
  return (
    <div className="celestial-container">
      <h1 className='celestialheading'>
        AT CELESTIAL, WE ARE COMMITTED TO 
        HELPING YOU DISCOVER THE 
        INCREDIBLE WISDOM THAT THE STARS 
        AND PLANETS HOLD. OUR 
        COMMITMENT INCLUDES:
      </h1>
    </div>
  );
};

export default Celestial;
